import React from "react";
import {
  HomeSpan,
  HomeBalanceContainer,
  HomeBox,
  HomeBoxWrapper,
  HomeBoxImg,
  HomeP01,
  SmallZero,
  HomeAmount,
  HomeBoxContainer,
} from "./homeBalance.styles";
import { IoWalletOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/rootReducer";
import { useQuery } from "@apollo/client";
import { getUserBankDetails } from "../../../../graphql/queries/accounts";
import environment from "../../../../env";
import { GET_TRANSACTION_BY_ORGANIZATION_ID } from "../../../../graphql/queries/transaction";

// import { Swiper, SwiperSlide } from "swiper/react";
// import "swiper/swiper-bundle.css";
// import './styles.css';

// Import required modules
// import Pagination from "swiper";

const Index = () => {
  const id = useSelector((state: RootState) => state.user?.user.id);

  // const paginationOptions = {
  //   clickable: true,
  //   renderBullet: (index: number, className: string) => {
  //     return `<span class="${className}">${index + 1}</span>`;
  //   },
  // };
  const navigate = useNavigate();

  const navigateToAccounts = () => {
    navigate("/dashboard/accounts");
  };
  const { data: queryData, refetch: refetchUserBankDetails } =
    useQuery(getUserBankDetails);

  const userBankDetails = queryData?.getUserBankDetails || {};
  const amount = userBankDetails?.userFinancialDetails?.available;
  const [mainAmount, smallZero] = amount?.toFixed(2)?.split(".") || "0";
  const checkerArr = Object.keys(userBankDetails);

  const {
    loading,
    error,
    data: getTransactionData,
  } = useQuery(GET_TRANSACTION_BY_ORGANIZATION_ID, {
    variables: {
      ...environment.paymentLinkService,
      payload: {
        limit: 10,
        page: 1,
      },
    },
  });
  const transaction =
    getTransactionData?.getAllTransactionsByOrganizationId?.data || 0;
  const transactionNo = transaction.length;

  const data = [
    {
      imgSrc: "",
      altText: "",
      title: "Account Balance",
      amount: `$${mainAmount}`,
      fraction: smallZero,
      backgroundColor: "#CCF4CD99",
      link: navigateToAccounts,
    },
    {
      imgSrc: "",
      altText: "",
      title: "Total Payout",
      amount: "$0",
      backgroundColor: "#CECCDE99",
    },
    {
      imgSrc: "",
      altText: "",
      title: "Total Inflow",
      amount: "$0",
      backgroundColor: "#CCF4CD99",
    },
    {
      imgSrc: "",
      altText: "",
      title: "Total No of Transactions",
      amount: transactionNo,
      backgroundColor: "#CECCDE99",
    },
  ];

  // const navigation = {
  //   spaceBetween: 30,
  // };

  // const pagination = {
  //   clickable: true,
  // };

  return (
    <HomeBalanceContainer>
      {/* {checkerArr.length === 0 ? (
        <span>Data Loading...</span>
      ) : (
        <>
          <HomeSpan>Balances</HomeSpan> */}
      {/* <Swiper
        pagination={pagination}
        modules={[Pagination]}
        className="mySwiper"
      > */}
      <HomeBoxContainer>
        {data.map((item, index) => (
          <HomeBox key={index} onClick={item.link}>
            <HomeBoxImg style={{ backgroundColor: item.backgroundColor }}>
              <IoWalletOutline style={{ fontSize: "25px" }} />
            </HomeBoxImg>
            <HomeBoxWrapper>
              <HomeP01>{item.title}</HomeP01>
              <HomeAmount>
                {item.amount}.<SmallZero>{item.fraction || "00"}</SmallZero>
              </HomeAmount>
            </HomeBoxWrapper>
          </HomeBox>
        ))}
      </HomeBoxContainer>
      {/* </> */}
      {/* )} */}
    </HomeBalanceContainer>
  );
};

export default Index;
